import { inView } from 'motion';
import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { isInView } from '@theme/utilities';

customElements.define(
  'sticky-buy-button',
  class StickyBuyButton extends HTMLElement {
    connectedCallback() {
      // Move to body to escape stacking context
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
        return; // connectedCallback will be called again after moving
      }

      this.addEventListener('click', (e) => {
        const target = /** @type {HTMLElement | null} */ (e.target);
        const anchor = target?.closest('a[href^="#"]');

        if (anchor) {
          e.preventDefault();
          const href = anchor.getAttribute('href');

          if (href) {
            document.querySelector(href)?.scrollIntoView({
              behavior: 'smooth',
            });
          }
        }
      });

      // Listen for variant updates
      document.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);

      const targetId = this.dataset.targetId;

      if (targetId) {
        const targetElement = document.getElementById(targetId);
        const footerElements = [...document.querySelectorAll('.shopify-section-group-footer-group')];

        /** @type {Map<string, boolean>} */
        const elementsInView = new Map([['target', isInView(targetElement)]]);
        footerElements.forEach((el, i) => elementsInView.set(`footer-${i}`, isInView(el)));

        const isVisible = () => ![...elementsInView.values()].some((value) => value);

        this.toggleAttribute('data-visible', isVisible());

        inView(
          /** @type {Element[]} */ ([targetElement, ...footerElements].filter((el) => el !== null)),
          (e) => {
            const key = e === targetElement ? 'target' : `footer-${footerElements.indexOf(e)}`;
            elementsInView.set(key, true);
            this.toggleAttribute('data-visible', isVisible());

            return () => {
              elementsInView.set(key, false);
              this.toggleAttribute('data-visible', isVisible());
            };
          },
          { amount: 'some' },
        );
      }

      const anchorLinks = this.querySelector('.sticky-buy-button__anchor-links');
      const PDPanchorLinks = document.querySelector('.product-information__anchor-links');

      if (anchorLinks && PDPanchorLinks) {
        anchorLinks.toggleAttribute('data-visible', !isInView(PDPanchorLinks));

        inView(
          PDPanchorLinks,
          () => {
            anchorLinks.toggleAttribute('data-visible', false);

            return () => {
              anchorLinks.toggleAttribute('data-visible', true);
            };
          },
          { amount: 'some' },
        );
      }
    }

    disconnectedCallback() {
      document.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
    }

    /**
     * Handles variant update events to sync with new variant
     * @param {import('@theme/events').VariantUpdateEvent} event
     */
    #onVariantUpdate = (event) => {
      const { html } = event.detail.data;

      const newStickyButton = html.querySelector('sticky-buy-button');
      if (newStickyButton) {
        morph(this, newStickyButton);
      }
    };
  },
);
